module.exports = __webpack_public_path__ + "img/c-01.3948bcbf.jpg";